import { render, staticRenderFns } from "./Lgx175492847615830912.vue?vue&type=template&id=65c39e60&"
import script from "./Lgx175492847615830912.vue?vue&type=script&lang=js&"
export * from "./Lgx175492847615830912.vue?vue&type=script&lang=js&"
import style0 from "./Lgx175492847615830912.vue?vue&type=style&index=0&id=65c39e60&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports